import { render, staticRenderFns } from "./FormAddPlanNew.vue?vue&type=template&id=81e65f8e&scoped=true"
import script from "./FormAddPlanNew.vue?vue&type=script&lang=js"
export * from "./FormAddPlanNew.vue?vue&type=script&lang=js"
import style0 from "./FormAddPlanNew.vue?vue&type=style&index=0&id=81e65f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e65f8e",
  null
  
)

export default component.exports